<script>
import Layout from "@/router/layouts/auth";
import { mapState, mapActions } from "vuex";
import { required, minLength } from "vuelidate/lib/validators";
import Languages from "@/components/widgets/languages";
import Password from "@/components/widgets/input-password";

export default {
  locales: {
    pt: {
      CHANGE: "ALTERAR",
      CPF: "CPF",
      "CPF is required.": "CPF é obrigatório",
      Password: "Senha",
      "Log In": "Entrar",
      "The CPF and/or password is incorrect.":
        "O CPF e/ou a senha estão incorretos.",
      "The login was successful.": "O login foi efetuado com sucesso.",
      "Forgot your password?": "Esqueceu sua senha?",
      "Don't have an account?": "Não possui uma conta?",
      "Signup now": "Cadastre-se",
    },
    es: {
      CHANGE: "CAMBIAR",
      CPF: "CPF",
      "CPF is required.": "Se requiere CPF",
      Password: "Contraseña",
      "Log In": "Iniciar sesión",
      "The CPF and/or password is incorrect.":
        "El CPF y/o contraseña son incorrectos.",
      "The login was successful.": "El inicio de sesión fue exitoso.",
      "Forgot your password?": "¿Olvidaste tu contraseña?",
      "Don't have an account?": "¿No tienes una cuenta?",
      "Signup now": "Regístrate ahora",
    },
  },
  components: {
    Layout,
    Languages,
    Password,
  },
  data() {
    return {
      language: "en",

      cpf: "",
      password: "",
      loading: false,
      submitted: false,

      user: {
        name: "",
        cpf: "",
        avatar: "",
      },
    };
  },
  computed: {
    ...mapState({
      account: (state) => state.account,
      alert: (state) => state.alert,
    }),
  },
  validations: {
    cpf: { required },
    password: { required, minLength: minLength(6) },
  },
  created() {
    this.logout();
  },
  methods: {
    ...mapActions("account", ["login", "logout"]),
    handleSubmit() {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        const { cpf, password } = this;
        if (cpf && password) {
          this.alert.type = "";
          this.alert.message = "";
          this.loading = true;
          this.$v.$reset();
          this.login({ cpf, password });
        }
      }
    },
    clearUser() {
      this.cpf = "";
      this.user.name = "";
      this.user.cpf = "";
      this.user.avatar = "";
    },
  },
  mounted() {
    if (this.$store.state.account.user) {
      this.cpf = this.$store.state.account.user.cpf;
      this.user.name = this.$store.state.account.user.name;
      this.user.cpf = this.$store.state.account.user.cpf;
      this.user.avatar = this.$store.state.account.user.avatar;
    }
  },
  watch: {
    "alert.type": function (alert) {
      if (alert == "alert-danger") {
        this.loading = false;
      }
    },
  },
};
</script>

<template>
  <Layout>
    <div id="auth" class="d-flex">
      <div class="login-content">
        <div class="pt-5 pb-3">
          <router-link class="align-middle" tag="a" to="/">
            <img class="w-100" style="max-width: 200px" src="@/assets/images/logo.png" />
          </router-link>
        </div>
        <div class="py-4">
          <b-form @submit.prevent="handleSubmit">
            <div v-if="alert.message" :class="'alert ' + alert.type">
              {{ alert.message }}
            </div>
            <b-form-group :label="t('CPF')" label-for="cpf">
              <b-form-input id="cpf" v-model="cpf" type="text" inputmode="numeric" :class="{ 'is-invalid': submitted && $v.cpf.$error }" v-mask="'###.###.###-##'"></b-form-input>
              <div v-if="submitted && !$v.cpf.required" class="invalid-feedback">
                {{ t("CPF is required.") }}
              </div>
            </b-form-group>
            <b-form-group label="Senha" label-for="password">
              <Password v-model="password" :v="$v.password"></Password>
            </b-form-group>
            <div class="mt-4">
              <b-button :disabled="loading == true" type="submit" variant="default" class="btn-lg btn-block">
                Entrar
                <b-spinner v-if="loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
              </b-button>
            </div>
          </b-form>
        </div>
        <div class="mt-2">
          <p class="text-dark">
            <router-link tag="a" to="/password-forgot" class="text-muted">
              <i class="mdi mdi-lock mr-1"></i>
              Esqueceu sua senha? </router-link><br />
            Não possui uma conta?
            <router-link tag="a" to="/register" class="font-weight-medium text-muted">Cadastre-se</router-link>
          </p>
          <Languages class="d-none" type="dropup"></Languages>
        </div>
      </div>
      <div class="flex-fill login-image d-none d-lg-block"></div>
    </div>
  </Layout>
</template>
